import LayoutMain from "@/lib/layout/LayoutMain";
import Organizations from "@/pages/organizations/Organizations";
import Done from "@/pages/done/Done";
import Login from "@/pages/auth/Login";
import Part from "@/pages/part/Part";
import Quote from "@/pages/quote/Quote";
import RFQ from "@/pages/rfq/RFQ";
import RFQs from "@/pages/rfqs/RFQs";
import Send from "@/pages/send/Send";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import LayoutRFQ from "./lib/layout/LayoutRFQ";
import Settings from "./pages/settings/Settings";
import Signup from "./pages/auth/Signup";
import ForgetPassword from "./pages/auth/ForgetPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import Profile from "./pages/profile/Profile";
import $api from "./lib/queries/openapi";
import { components } from "./lib/ApiSchema";
import StyledLink from "./lib/StyledLink";

export default function Router() {
  const {
    data: user,
    isPending,
    isSuccess, // needed for logout
  } = $api.useQuery("get", "/api/user");

  if (isPending) return null;

  const teamSlug = user?.teams.length === 1 ? user.teams[0]?.slug : "";

  return (
    <BrowserRouter>
      <Routes>
        <Route path="health" element={<div>OK</div>} />
        {isSuccess && user ? (
          <>
            <Route
              index
              element={<Navigate to={`/teams/${teamSlug}`} replace />}
            />
            <Route path="teams/:teamSlug" element={<LayoutMain user={user} />}>
              <Route index element={<Navigate to="rfqs" replace />} />
              <Route path="organizations" element={<Organizations />} />
              <Route path="settings/*" element={<Settings user={user} />} />
              <Route path="profile" element={<Profile user={user} />} />
              <Route path="rfqs">
                <Route index element={<RFQs />} />
                <Route element={<LayoutRFQ />}>
                  <Route path=":rfqId" element={<RFQ />} />
                  <Route path=":rfqId/parts/:partId" element={<Part />} />
                  <Route path=":rfqId/quote" element={<Quote />} />
                  <Route path=":rfqId/send" element={<Send />} />
                  <Route path=":rfqId/done" element={<Done />} />
                </Route>
              </Route>
            </Route>
            <Route
              path="*"
              element={
                user.teams.length === 0 ? (
                  <Fallback
                    paragraph="You're not a member of any team."
                    teams={[]}
                  />
                ) : user.teams.length === 1 ? (
                  <Navigate to={`/teams/${teamSlug}`} replace />
                ) : (
                  <Fallback
                    paragraph="You have multiple team memberships. Click one to continue:"
                    teams={user.teams}
                  />
                )
              }
            />
          </>
        ) : (
          <>
            <Route index element={<Navigate to="/login" replace />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="forgot-password" element={<ForgetPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

function Fallback({
  paragraph,
  teams,
}: {
  paragraph: string;
  teams: components["schemas"]["UserTeamSchema"][];
}) {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center text-center">
      <div>{paragraph}</div>
      <div className="flex flex-col gap-2 mt-2">
        {teams.map(({ slug, name }) => (
          <StyledLink key={slug} to={`/teams/${slug}`}>
            {name}
          </StyledLink>
        ))}
      </div>
    </div>
  );
}
